// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from "react";
// import { InputAdornment } from "@material-ui/core";
// import _ from "lodash";
// import LogRocket from "logrocket";
// // import Smartlook from "smartlook-client";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import { Button, Input, Modal } from "../../../components/common";
// import {
//   userLoginRequest,
//   resetLoginFlag,
//   userLoginSuccess
// } from "../../../reducers/auth/login.reducer";
// import {
//   setCurrentCompanyRequest,
//   setSessionTokenRequest,
//   setSessionUserRequest,
// } from "../../../reducers/auth/session.reducer";
// import appRoutes from "../../../routes/app.routes";
// import { ReactComponent as PersonIcon } from "../../../assets/svg/person.svg";
// import { ReactComponent as LockIcon } from "../../../assets/svg/lock.svg";
// import Affirmation from "../../../components/common/Affirmation";
// import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
// import { COMPANY_FLAG } from "../../../utils/appConstants";
// import httpRequest from "../../../utils/httpRequest";
// import API_URLS from "../../../utils/apiUrls";
// import verificationImage from "../../../assets/svg/twofa.svg";
// import CodeEnter from "../../../components/common/CodeEnter";

// type Inputs = {
//   email: string;
//   password: string;
//   recoveryKey: string;
// };

// const Login: React.FC = () => {
//   const logRocketAppId = process.env.REACT_APP_LOG_ROCKET;
//   const smartLookAppId = process.env.REACT_APP_SMART_LOOK;
//   const [twoFA, setTwoFA] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [inputValues, setInputValues] = useState(Array(6).fill(''));
//   const [tokenVerifyError, setTokenVerifyError] = useState('')
//   const [clearFlag, setClearFlag] = useState(false);
//   const [recoveryModal, setRecoveryModal] = useState(false);
//   const [recoveryKey, setRecoveryKey] = useState("");
//   const [recoveryVerifyError, setRecoveryVerifyError] = useState("");
//   const [isLoadVerify, SetIsLoadVerify] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const {
//     loading,
//     message: loginError,
//     flag: loginFlag,
//     data,
//   } = useSelector(({ auth }: any) => auth.login);

//   const { register, handleSubmit, formState:{errors} } = useForm<Inputs>();
//   const userToken = data?.token

//   useEffect(() => {
//     if (data?.twoFAVerificationRequired) {
//       setTwoFA(true)
//       setOpen(true)
//       setClearFlag(false)
//     } else {
//       if (loginFlag === true) {
//         const token = _.get(data, "token", null);
//         const sessionData = _.get(data, "session", {});

//         // Set session data
//         dispatch(setSessionTokenRequest(token));
//         dispatch(setSessionUserRequest(sessionData));

//         // Navigate user based on role
//         const IS_COMPANY =
//           _.get(data, "session.is_company") === COMPANY_FLAG.YES ? true : false;
//         let companyDetails =
//           sessionData?.companies?.find((row) => row.privileges === true) || null;

//         // Check for first company access
//         if (!companyDetails) {
//           companyDetails = sessionData?.companies[0] || {};
//         }

//         const companySlug = companyDetails.slug || "";
//         const userId = sessionData.id;
//         const email = sessionData.email;
//         const firstName = sessionData.first_name;

//         if (IS_COMPANY && companySlug) {
//           // LogRocket User Identity
//           if (logRocketAppId) {
//             LogRocket.identify(logRocketAppId, {
//               name: firstName,
//               email: email,
//               companySlug: companySlug,
//             });
//           }

//           // Smartlook User Identity
//           // if (smartLookAppId) {
//           //   Smartlook.identify(userId, {
//           //     name: firstName,
//           //     email: email,
//           //     companySlug: companySlug,
//           //   });
//           // }

//           // Set the company
//           dispatch(setCurrentCompanyRequest(companyDetails));
//           const companyPath =
//             appRoutes.companyDashboard.generatePath(companySlug);
//           navigate(companyPath);
//         } else {
//           // LogRocket User Identity
//           if (logRocketAppId) {
//             LogRocket.identify(logRocketAppId, {
//               name: firstName,
//               email: email,
//             });
//           }

//           // Smartlook User Identity
//           if (smartLookAppId) {
//             Smartlook.identify(userId, {
//               name: firstName,
//               email: email,
//             });
//           }
//           navigate(appRoutes.candidateProfileView.path);
//         }

//         dispatch(resetLoginFlag());
//       }
//     }

//   }, [loginFlag, data, dispatch, navigate]);

//   const verifyToken = async () => {
//     SetIsLoadVerify(true);

//     try {
//       if (!inputValues.includes('')) {
//         const verifyCode = inputValues.join('');
//         const payload = {
//           token: verifyCode,
//           userToken: userToken
//         };
//         const data = await httpRequest().post(API_URLS.verifyToken, payload);

//         if (data.data.data.delta === 0) {
//           // Successful verification, dispatch login success action
//           dispatch(userLoginSuccess({
//             messages: data.data.message,
//             data: data.data.data
//           }));
//         } else {
//           setTokenVerifyError('Enter valid verification code');
//         }
//       } else {
//         setTokenVerifyError("Please enter 6 digit verification code");
//       }
//     } catch (error) {
//       setTokenVerifyError("An error occurred while verifying the code. Please try again.");
//     } finally {
//       SetIsLoadVerify(false);
//     }
//   };

//   const verifyRecoveryKey = async () => {
//     SetIsLoadVerify(true);
//     try {
//       const payload = {
//         recoveryKey: recoveryKey,
//         userToken: userToken,
//       };
//       const response = await httpRequest().post(API_URLS.verifyRecovery, payload);

//       if (response.data.data.isVerify) {
//         dispatch(userLoginSuccess({
//           messages: response.data.message,
//           data: response.data.data,
//         }));
//         setRecoveryKey("");
//         setRecoveryModal(false);
//         setRecoveryVerifyError("");
//       }
//     } catch (error) {
//       setRecoveryVerifyError(error.response.data.data.message);
//     }
//     finally {
//       SetIsLoadVerify(false)
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setInputValues(Array(6).fill(''));
//     setTokenVerifyError('')
//     setClearFlag(true);
//   }

//   const handleInputChange = (index, value) => {
//     if (value.length === 1) {
//       setInputValues(prevValues => {
//         const newValues = [...prevValues];
//         newValues[index] = value;
//         return newValues;
//       });
//     }
//   };

//   const onSubmit = async (formData) => {
//     dispatch(
//       userLoginRequest({
//         email: formData.email,
//         password: formData.password,
//         action: "login",
//         isVerify: false
//       })
//     );
//   };

//   useEffect(() => {
//     if (!inputValues.includes('') && inputValues.length === 6) {
//       verifyToken();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [inputValues])

//   return (
//     <>
//       <div className="left-part">
//         <Affirmation />
//       </div>
//       <div className="right-part">
//         <div className="">
//           <div className="back-website">
//             <div className="back">
//               <Link to={appRoutes.home.path}>
//                 {" "}
//                 <ArrowBackIosIcon />{" "}
//               </Link>
//             </div>
//             <Link to={appRoutes.home.path}>Back to website</Link>
//           </div>
//           <div className="auth-card auth-login-wrapper">
//             <h2 className="auth-card-title">Login</h2>
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <div className="form-group">
//                 <p className="form-group-label">Email</p>
//                 <Input
//                   // name="email"
//                   placeholder="Email"
//                   validationObj={errors}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <PersonIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   {...register("email",{
//                     required: {
//                       value: true,
//                       message: "Please enter email address",
//                     },
//                     pattern: {
//                       value: /\S+@\S+\.\S+/,
//                       message: "Enter valid email address",
//                     },
//                   })}
//                 />
//               </div>
//               <div className="form-group">
//                 <p className="form-group-label">Password</p>
//                 <Input
//                   type="password"
//                   // name="password"
//                   placeholder="Password"
//                   validationObj={errors}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LockIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   {...register("password", {
//                     required: {
//                       value: true,
//                       message: "Please enter password",
//                     },
//                     minLength: {
//                       value: 4,
//                       message: "Password must be between 4 to 16 characters",
//                     },
//                   })}
//                 />
//                 {/* {!twoFA && loginError && (
//                   <span className="text-sm text-danger error-helper">
//                     {loginError}
//                   </span>
//                 )} */}
//                 {loginError && (
//                   <span className="text-sm text-danger error-helper">
//                     {loginError}
//                   </span>
//                 )}

//               </div>
//               {twoFA && (
//                 <>
//                   <Modal
//                     className="login-verification"
//                     visible={open}
//                     onClose={() => handleClose()}
//                   >
//                     <h2 className="text-qr">Two-Step Verification</h2>
//                     <div className="email-img" ><img src={verificationImage} alt="" /></div>
//                     <div className="info">Enter your code to complete Login </div>
//                     <div className="info"><span>Open the verification app on your phone <br /> to get your verification app</span></div>

//                     <CodeEnter
//                       clear={clearFlag}
//                       handleOnChange={(index, e) => handleInputChange(index, e.target.value)}
//                     />

//                     <div className="error-verify">
//                       {tokenVerifyError && (
//                         <span className="text-sm text-danger error-helper">
//                           {tokenVerifyError}
//                         </span>
//                       )}
//                     </div>
//                     <div>
//                       <Button
//                         onClick={() => verifyToken()}
//                         color="primary"
//                       >
//                         Login
//                       </Button>
//                     </div>
//                     <p
//                       className="authentication-link"
//                       onClick={() => {
//                         setRecoveryModal(true)
//                         setOpen(false)
//                       }
//                       }>Haven't Device,Use recovery Key.</p>

//                   </Modal>

//                 </>
//               )}
//               {recoveryModal && (
//                 <>
//                   <Modal
//                     className="login-verification"
//                     visible={recoveryModal}
//                     onClose={() => {
//                       setRecoveryModal(false);
//                       setRecoveryVerifyError("");
//                     }}
//                   >
//                     <h2 className="text-qr">Enter Your Recover Key</h2>
//                     <Input
//                       type="text"
//                       // name="recovery-key"
//                       placeholder="Enter your recovery key"
//                       validationObj={errors}
//                       // onChange={(e) => setRecoveryKey(e.target.value)}
//                       {...register("recoveryKey", {
//                         required: {
//                           value: true,
//                           message: "Please enter Recovery Key",
//                         },
//                       })}
//                     />
//                     <div className="error-verify">
//                       {recoveryVerifyError && (
//                         <span className="text-sm text-danger error-helper">
//                           {recoveryVerifyError}
//                         </span>
//                       )}
//                     </div>
//                     <div>
//                       <Button
//                         onClick={() => verifyRecoveryKey()}
//                         color="primary"
//                         loading={isLoadVerify}
//                       >
//                         Login
//                       </Button>
//                     </div>
//                     <p
//                       className="authentication-link"
//                       onClick={() => {
//                         setRecoveryModal(false);
//                         setOpen(true);
//                       }}
//                     >
//                       Haven Device? Use authentication Code.
//                     </p>
//                   </Modal>
//                 </>
//               )}

//               <div className="form-group btn-group">
//                 <Button type="submit" color="primary" loading={loading}>
//                   Login
//                 </Button>
//               </div>
//               <div className="form-group text-center">
//                 <Link to={appRoutes.userForgotPassword.path}>
//                   {appRoutes.userForgotPassword.title}
//                 </Link>
//               </div>
//             </form>
//           </div>
//           <p className="outer-link">
//             If you don’t have an account?{" "}
//             <Link to={appRoutes.userSignUp.path}>
//               {appRoutes.userSignUp.title}
//             </Link>
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import { InputAdornment } from "@material-ui/core";
import _ from "lodash";
import LogRocket from "logrocket";
// import Smartlook from "smartlook-client";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button, Checkbox, FlashMessage, Input, Modal } from "../../../components/common";
import {
  userLoginRequest,
  resetLoginFlag,
  userLoginSuccess,
} from "../../../reducers/auth/login.reducer";
import {
  setCurrentCompanyRequest,
  setSessionTokenRequest,
  setSessionUserRequest,
} from "../../../reducers/auth/session.reducer";
import appRoutes from "../../../routes/app.routes";
import { ReactComponent as EnvelopeIcon } from "../../../assets/svg/envelope.svg";
import { ReactComponent as LockIcon } from "../../../assets/svg/lock.svg";
import Affirmation from "../../../components/common/Affirmation";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { COMPANY_FLAG } from "../../../utils/appConstants";
import { socialLoginErrorMessage } from "../../../utils/helper";
import httpRequest from "../../../utils/httpRequest";
import API_URLS from "../../../utils/apiUrls";
import verificationImage from "../../../assets/svg/twofa.svg";
import CodeEnter from "../../../components/common/CodeEnter";
import { Apple } from "@material-ui/icons";
import "../../../utils/firebase";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import GoogleSVG from "../../../assets/svg/Googlesvg";

const REMEMBER_ME_KEY = "eh_remember_me";
const REMEMBER_EMAIL_KEY = "eh_remember_email";

const getRememberedLogin = () => {
  try {
    const rememberMe = localStorage.getItem(REMEMBER_ME_KEY) === "true";
    const email = rememberMe
      ? localStorage.getItem(REMEMBER_EMAIL_KEY) || ""
      : "";
    return { rememberMe, email };
  } catch {
    return { rememberMe: false, email: "" };
  }
};

type Inputs = {
  email: string;
  password: string;
  recoveryKey: string;
  rememberMe: boolean;
};

const Login: React.FC = () => {
  const logRocketAppId = process.env.REACT_APP_LOG_ROCKET;
  const smartLookAppId = process.env.REACT_APP_SMART_LOOK;

  const [twoFA, setTwoFA] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValues, setInputValues] = useState(Array(6).fill(""));
  const [tokenVerifyError, setTokenVerifyError] = useState("");
  const [clearFlag, setClearFlag] = useState(false);
  const [recoveryModal, setRecoveryModal] = useState(false);
  const [recoveryKey, setRecoveryKey] = useState("");
  const [recoveryVerifyError, setRecoveryVerifyError] = useState("");
  const [isLoadVerify, SetIsLoadVerify] = useState(false);

  // Social login UI state
  const [socialLoading, setSocialLoading] = useState<null | "google" | "apple">(
    null
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    loading,
    message: loginError,
    flag: loginFlag,
    data,
  } = useSelector(({ auth }: any) => auth.login);

  const rememberedLogin = getRememberedLogin();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      email: rememberedLogin.email,
      rememberMe: rememberedLogin.rememberMe,
    },
  });
  const rememberMeChecked = watch("rememberMe");
  const userToken = data?.token;

  const [isMac, setIsMac] = useState(false);

  useEffect(() => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes("mac")) {
      setIsMac(true);
    }
  }, []);

  useEffect(() => {
    if (data?.twoFAVerificationRequired) {
      setTwoFA(true);
      setOpen(true);
      setClearFlag(false);
    } else {
      if (loginFlag === true) {
        const token = _.get(data, "token", null);
        const sessionData = _.get(data, "session", {});

        dispatch(setSessionTokenRequest(token));
        dispatch(setSessionUserRequest(sessionData));

        const IS_COMPANY =
          _.get(data, "session.is_company") === COMPANY_FLAG.YES ? true : false;
        let companyDetails =
          sessionData?.companies?.find((row: any) => row.privileges === true) ||
          null;

        if (!companyDetails) {
          companyDetails = sessionData?.companies[0] || {};
        }

        const companySlug = companyDetails?.slug || "";
        const email = sessionData?.email;
        const firstName = sessionData?.first_name;

        if (IS_COMPANY && companySlug) {
          if (logRocketAppId) {
            LogRocket.identify(logRocketAppId, {
              name: firstName,
              email: email,
              companySlug: companySlug,
            });
          }
          dispatch(setCurrentCompanyRequest(companyDetails));
          const companyPath =
            appRoutes.companyDashboard.generatePath(companySlug);
          navigate(companyPath);
        } else {
          if (logRocketAppId) {
            LogRocket.identify(logRocketAppId, {
              name: firstName,
              email: email,
            });
          }
          navigate(appRoutes.candidateProfileView.path);
        }

        dispatch(resetLoginFlag());
      }
    }
  }, [loginFlag, data, dispatch, navigate, logRocketAppId, smartLookAppId]);

  useEffect(() => {
    if (loginFlag === false && loginError) {
      FlashMessage(loginError, "error");
      // optionally reset flag to avoid repeated flashes
      dispatch(resetLoginFlag());
    }
  }, [loginFlag, loginError, dispatch]);

  const verifyToken = async () => {
    SetIsLoadVerify(true);
    try {
      if (!inputValues.includes("")) {
        const verifyCode = inputValues.join("");
        const payload = { token: verifyCode, userToken };
        const data = await httpRequest().post(API_URLS.verifyToken, payload);

        if (data.data.data.delta === 0) {
          dispatch(
            userLoginSuccess({
              messages: data.data.message,
              data: data.data.data,
            })
          );
        } else {
          setTokenVerifyError("Enter valid verification code");
        }
      } else {
        setTokenVerifyError("Please enter 6 digit verification code");
      }
    } catch {
      setTokenVerifyError(
        "An error occurred while verifying the code. Please try again."
      );
    } finally {
      SetIsLoadVerify(false);
    }
  };

  const verifyRecoveryKey = async () => {
    SetIsLoadVerify(true);
    try {
      const payload = { recoveryKey, userToken };
      const response = await httpRequest().post(
        API_URLS.verifyRecovery,
        payload
      );

      if (response.data.data.isVerify) {
        dispatch(
          userLoginSuccess({
            messages: response.data.message,
            data: response.data.data,
          })
        );
        setRecoveryKey("");
        setRecoveryModal(false);
        setRecoveryVerifyError("");
      }
    } catch (error: any) {
      setRecoveryVerifyError(
        error?.response?.data?.data?.message || "Invalid recovery key"
      );
    } finally {
      SetIsLoadVerify(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setInputValues(Array(6).fill(""));
    setTokenVerifyError("");
    setClearFlag(true);
  };

  const handleInputChange = (index: number, value: string) => {
    if (value.length === 1) {
      setInputValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = value;
        return newValues;
      });
    }
  };

  const onSubmit = async (formData: Inputs) => {
    try {
      if (formData.rememberMe) {
        localStorage.setItem(REMEMBER_ME_KEY, "true");
        localStorage.setItem(REMEMBER_EMAIL_KEY, formData.email || "");
      } else {
        localStorage.removeItem(REMEMBER_ME_KEY);
        localStorage.removeItem(REMEMBER_EMAIL_KEY);
      }
    } catch {
      // Ignore storage errors; login should still proceed.
    }

    dispatch(
      userLoginRequest({
        email: formData.email,
        password: formData.password,
        action: "login",
        isVerify: false,
      })
    );
  };

  useEffect(() => {
    if (!inputValues.includes("") && inputValues.length === 6) {
      verifyToken();
    }
    // eslint-disable-next-line
  }, [inputValues]);

  const auth = getAuth();

  const handleSocialLogin = async (providerKey: "google" | "apple") => {
    setSocialLoading(providerKey);

    try {
      let provider;

      if (providerKey === "google") {
        provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });
      } else {
        provider = new OAuthProvider("apple.com");
      }

      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();
      const resp = await httpRequest().post(API_URLS.socialLogin, { idToken });

      const respData = _.get(resp, "data.data", {});
      // Dispatch login success into reducer
      dispatch(
        userLoginSuccess({
          messages: _.get(resp, "data.message", ""),
          data: respData,
        })
      );

      // If API returned token/session, persist session immediately
      const token = _.get(respData, "token", null);
      const sessionData = respData.session || respData || {};
      if (token) dispatch(setSessionTokenRequest(token));
      if (sessionData && Object.keys(sessionData).length > 0) {
        dispatch(setSessionUserRequest(sessionData));
      }

      // If backend indicates profile completion is NOT required, go to home
      const requiresProfileCompletion = _.get(
        respData,
        "requiresProfileCompletion",
        true
      );
      if (requiresProfileCompletion === false) {
        navigate(appRoutes.home.path);
        return;
      }
      // otherwise fallback to normal candidate flow (profile view)
      navigate(appRoutes.candidateProfileView.path);
    } catch (err: unknown) {
      console.log("Social login error---:", err);
      FlashMessage(socialLoginErrorMessage(err), "error");
    } finally {
      setSocialLoading(null);
    }
  };

  return (
    <>
      <div className="left-part">
        <Affirmation />
      </div>
      <div className="right-part">
        <div className="">
          <div className="back-website">
            <div className="back">
              <Link to={appRoutes.home.path}>
                <ArrowBackIosIcon />
              </Link>
            </div>
            <Link to={appRoutes.home.path}>Back to website</Link>
          </div>

          <div className="auth-card auth-login-wrapper">
            <h2 className="auth-card-title">Login</h2>

            {/* Email/Password */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <Input
                  externalLabel={{ label: "Email" }}
                  placeholder="Email"
                  validationObj={errors}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EnvelopeIcon />
                      </InputAdornment>
                    ),
                  }}
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Please enter email address",
                    },
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Enter valid email address",
                    },
                  })}
                />
              </div>

              <div className="form-group mb-20">
                <Input
                  type="password"
                  externalLabel={{ label: "Password" }}
                  placeholder="Password"
                  validationObj={errors}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                  }}
                  {...register("password", {
                    required: { value: true, message: "Please enter password" },
                    minLength: {
                      value: 4,
                      message: "Password must be between 4 to 16 characters",
                    },
                  })}
                />
              </div>

              <div className="login-options-row">
                <Checkbox
                  color="primary"
                  externalLabel={{ label: "Remember me" }}
                  checked={!!rememberMeChecked}
                  {...register("rememberMe")}
                />
                <Link
                  className="forgot-password-link"
                  to={appRoutes.userForgotPassword.path}
                >
                  Forgot Password?
                </Link>
              </div>

              {/* 2FA Modal */}
              {twoFA && (
                <Modal
                  className="login-verification"
                  visible={open}
                  onClose={handleClose}
                >
                  <h2 className="text-qr">Two-Step Verification</h2>
                  <div className="email-img">
                    <img src={verificationImage} alt="" />
                  </div>
                  <div className="info">Enter your code to complete Login</div>
                  <div className="info">
                    <span>
                      Open the verification app on your phone <br /> to get your
                      verification app
                    </span>
                  </div>

                  <CodeEnter
                    clear={clearFlag}
                    handleOnChange={(index, e) =>
                      handleInputChange(index, e.target.value)
                    }
                  />

                  <div className="error-verify">
                    {tokenVerifyError && (
                      <span className="text-sm text-danger error-helper">
                        {tokenVerifyError}
                      </span>
                    )}
                  </div>
                  <div>
                    <Button onClick={verifyToken} color="primary">
                      Login
                    </Button>
                  </div>
                  <p
                    className="authentication-link"
                    onClick={() => {
                      setRecoveryModal(true);
                      setOpen(false);
                    }}
                  >
                    Don’t have your device? Use a recovery key
                  </p>
                </Modal>
              )}

              {/* Recovery Modal */}
              {recoveryModal && (
                <Modal
                  className="login-verification"
                  visible={recoveryModal}
                  onClose={() => {
                    setRecoveryModal(false);
                    setRecoveryVerifyError("");
                  }}
                >
                  <Input
                    type="text"
                    placeholder="Enter your recovery key"
                    validationObj={errors}
                    {...register("recoveryKey", {
                      required: {
                        value: true,
                        message: "Please enter Recovery Key",
                      },
                    })}
                    externalLabel={{
                      label: "Enter your recovery key",
                      className: "recovery-key-input",
                    }}
                    onChange={(e: any) => setRecoveryKey(e.target.value)}
                  />
                  <div className="error-verify">
                    {recoveryVerifyError && (
                      <span className="text-sm text-danger error-helper">
                        {recoveryVerifyError}
                      </span>
                    )}
                  </div>
                  <div>
                    <Button
                      onClick={verifyRecoveryKey}
                      color="primary"
                      loading={isLoadVerify}
                    >
                      Login
                    </Button>
                  </div>
                  <p
                    className="authentication-link"
                    onClick={() => {
                      setRecoveryModal(false);
                      setOpen(true);
                    }}
                  >
                    Don't have your device? Use a recovery key
                  </p>
                </Modal>
              )}

              <div className="form-group btn-group">
                <Button type="submit" color="primary" loading={loading}>
                  Login
                </Button>
              </div>
            </form>

            {/* Divider */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                margin: "16px 0",
                fontWeight: 500,
              }}
            >
              <span style={{ flex: 1, height: 2, background: "#eee" }} />
              <span style={{ fontSize: "var(--fs-body2)", color: "#999" }}>
                Or Continue With
              </span>
              <span style={{ flex: 1, height: 2, background: "#eee" }} />
            </div>

            <div className="social-login d-flex justify-content-center ">
              <Button
                onClick={() => handleSocialLogin("google")}
                loading={socialLoading === "google"}
                variant="outlined"
                color="social"
              >
                <GoogleSVG />
                &nbsp;Google
              </Button>

              {isMac && (
                <Button
                  onClick={() => handleSocialLogin("apple")}
                  loading={socialLoading === "apple"}
                  variant="outlined"
                  color="social"
                >
                  <Apple style={{ color: "#000" }} />
                  &nbsp;Apple
                </Button>
              )}
            </div>
          </div>

          <p className="outer-link">
            If you don’t have an account?{" "}
            <Link to={appRoutes.userSignUp.path}>
              {appRoutes.userSignUp.title}
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
